document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

document.addEventListener('DOMContentLoaded', () => {
  const hero = document.querySelector('.ak-hero');
  if (hero) requestAnimationFrame(() => hero.classList.add('is-loaded'));

  const stage = document.querySelector('[data-ak-stage]');
  if (stage && matchMedia('(pointer:fine)').matches) {
    stage.addEventListener('pointermove', (e) => {
      const r = stage.getBoundingClientRect();
      const x = (e.clientX - r.left) / r.width - .5;
      const y = (e.clientY - r.top) / r.height - .5;
      stage.style.setProperty('--mx', `${x * 16}px`);
      stage.style.setProperty('--my', `${y * 12}px`);
    });
    stage.addEventListener('pointerleave', () => {
      stage.style.setProperty('--mx', '0px');
      stage.style.setProperty('--my', '0px');
    });
  }

  const io = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: .14 });
  document.querySelectorAll('[data-ak-scroll], [data-ak-card]').forEach(el => io.observe(el));
});
